import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49bf1de9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-left":"5px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "消息中心", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarLogo = _resolveComponent("SidebarLogo")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'has-logo': _ctx.showLogo }, "sideWrap"])
  }, [
    (_ctx.showLogo)
      ? (_openBlock(), _createBlock(_component_SidebarLogo, {
          key: 0,
          collapse: _ctx.isCollapse
        }, null, 8, ["collapse"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_scrollbar, { "wrap-class": "scrollbar-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          "default-active": _ctx.activeMenu,
          collapse: !_ctx.isCollapse,
          class: _normalizeClass([_ctx.isCollapse ? 'el-menu-vertical-demo' : '']),
          "unique-opened": "",
          router: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item) => {
              return (_openBlock(), _createBlock(_component_el_sub_menu, {
                index: item.path,
                key: item.path
              }, {
                title: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(['menu-icon', item.icon])
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: child.path,
                      index: child.path
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(child.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128)),
            _createVNode(_component_el_menu_item, { index: "/notice/list" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass({
                  'menu-icon': true,
                  'notice-icon': true,
                  'notice-icon-active': _ctx.activeMenu === '/notice/list',
                })
                    }, null, 2)
                  ]),
                  _: 1
                }),
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active", "collapse", "class"])
      ]),
      _: 1
    })
  ], 2))
}